import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

// import p1 from 'assests/Photos/knowmore/Photogallry/1.jpg';
// import p2 from 'assests/Photos/knowmore/Photogallry/7.jpg';
// import p3 from 'assests/Photos/knowmore/Photogallry/9.jpg';
// import p4 from 'assests/Photos/knowmore/Photogallry/10.jpg';
// import p5 from 'assests/Photos/knowmore/Photogallry/11.jpg';
// import p6 from 'assests/Photos/knowmore/Photogallry/IMG_0695.jpg';
// import p7 from 'assests/Photos/knowmore/Photogallry/IMG_0698.jpg';
// import p8 from 'assests/Photos/knowmore/Photogallry/IMG_0701.jpg';
// import p9 from 'assests/Photos/knowmore/Photogallry/IMG_0715.jpg';
// import p10 from 'assests/Photos/knowmore/Photogallry/2.jpg';
// import p11 from 'assests/Photos/knowmore/Photogallry/5.jpg';
// import p12 from 'assests/Photos/knowmore/Photogallry/6.jpg';
// import p13 from 'assests/Photos/knowmore/Photogallry/8.jpg';
// import p14 from 'assests/Photos/knowmore/Photogallry/IMG_0653.jpg';
// import p15 from 'assests/Photos/knowmore/Photogallry/IMG_0654.jpg';
// import p16 from 'assests/Photos/knowmore/Photogallry/IMG_0693.jpg';
// import p17 from 'assests/Photos/knowmore/Photogallry/IMG_0718.jpg';

// import p18 from 'assests/Photos/knowmore/Photogallry/IMG_0723.jpg';
// import p19 from 'assests/Photos/knowmore/Photogallry/IMG_0747.jpg';
// import p20 from 'assests/Photos/knowmore/Photogallry/IMG_0824.jpg';
// import p21 from 'assests/Photos/knowmore/Photogallry/IMG_0824.jpg';
// import p22 from 'assests/Photos/knowmore/Photogallry/IMG_0854.jpg';
// import p23 from 'assests/Photos/knowmore/Photogallry/12.jpg';

// import p24 from 'assests/Photos/knowmore/Photogallry/IMG_0734.jpg';
// import p25 from 'assests/Photos/knowmore/Photogallry/IMG_0751.jpg';
// import p26 from 'assests/Photos/knowmore/Photogallry/IMG_0757.jpg';
// import p27 from 'assests/Photos/knowmore/Photogallry/IMG_0769.jpg';
// import p28 from 'assests/Photos/knowmore/Photogallry/IMG_0839.jpg';
// import p29 from 'assests/Photos/knowmore/Photogallry/IMG_0848.jpg';
// import p30 from 'assests/Photos/knowmore/Photogallry/IMG_0871.jpg';

// import p31 from 'assests/Photos/knowmore/Photogallry/IMG_0877.jpg';
// import p32 from 'assests/Photos/knowmore/Photogallry/IMG_0884.jpg';
// import p33 from 'assests/Photos/knowmore/Photogallry/IMG_0878.jpg';
// import p34 from 'assests/Photos/knowmore/Photogallry/IMG_0893.jpg';
// import p35 from 'assests/Photos/knowmore/Photogallry/IMG_0894.jpg';
// import p36 from 'assests/Photos/knowmore/Photogallry/IMG_0895.jpg';
// import p37 from 'assests/Photos/knowmore/Photogallry/IMG_0896.jpg';
// import p38 from 'assests/Photos/knowmore/Photogallry/IMG_0897.jpg';
// import p39 from 'assests/Photos/knowmore/Photogallry/IMG_0898.jpg';

// import p40 from 'assests/Photos/knowmore/Photogallry/IMG_0904.jpg';
// import p41 from 'assests/Photos/knowmore/Photogallry/IMG_0905.jpg';
// import p43 from 'assests/Photos/knowmore/Photogallry/IMG_0907.jpg';
// import p42 from 'assests/Photos/knowmore/Photogallry/IMG_0908.jpg';
// import p44 from 'assests/Photos/knowmore/Photogallry/IMG_0910.jpg';
// import p45 from 'assests/Photos/knowmore/Photogallry/IMG_0916.jpg';
// import p46 from 'assests/Photos/knowmore/Photogallry/IMG_0919.jpg';
// import p47 from 'assests/Photos/knowmore/Photogallry/IMG_0922.jpg';
// import p48 from 'assests/Photos/knowmore/Photogallry/IMG_0925.jpg';
// import p49 from 'assests/Photos/knowmore/Photogallry/IMG_0926.jpg';
// import p50 from 'assests/Photos/knowmore/Photogallry/IMG_0934.jpg';
// import p51 from 'assests/Photos/knowmore/Photogallry/IMG_0943.jpg';
// import p52 from 'assests/Photos/knowmore/Photogallry/IMG_1026.jpg';
// import p53 from 'assests/Photos/knowmore/Photogallry/IMG_0983.jpg';
// import p54 from 'assests/Photos/knowmore/Photogallry/KG II - 1.jpg';
// import p55 from 'assests/Photos/knowmore/Photogallry/KG II - 2.jpg';
// import p56 from 'assests/Photos/knowmore/Photogallry/KG II - 3.jpg';
// import p57 from 'assests/Photos/knowmore/Photogallry/KG II - 4.jpg';
// import p58 from 'assests/Photos/knowmore/Photogallry/KG II - 8.jpg';
// import p59 from 'assests/Photos/knowmore/Photogallry/KG II - 5.jpg';


const MostViewedArticles = () => {

  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_archive_url: '' });
useEffect(() => {
  fetch('/config.json')
    .then(response => response.json())
    .then(data => setConfig(data))
    .catch(error => console.error('Error fetching config:', error));
}, []);

const p1 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry1.webp`;
const p2 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry7.webp`;
const p3 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry9.webp`;
const p4 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry10.webp`;
const p5 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry11.webp`;
const p6 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0695.webp`;
const p7 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0698.webp`;
const p8 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0701.webp`;
const p9 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0715.webp`;
const p10 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry2.webp`;
const p11 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry5.webp`;
const p12 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry6.webp`;
const p13 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry8.webp`;
const p14 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0653.webp`;
const p15 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0654.webp`;
const p16 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0693.webp`;
const p17 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0718.webp`;
const p18 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0723.webp`;

const p19 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0747.webp`;
const p20 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0824.webp`;
const p21 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0824.webp`;
const p22 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0854.webp`;
const p23 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/Photogallry12.webp`;

const p24 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0734.webp`;
const p25 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0751.webp`;
const p26 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0757.webp`;
const p27 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0769.webp`;

const p28 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0839.webp`;
const p29 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0848.webp`;
const p30 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0871.webp`;

const p31 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0877.webp`;
const p32 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0884.webp`;
const p33 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0878.webp`;
const p34 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0893.webp`;
const p35 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0894.webp`;
const p36 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0895.webp`;
const p37 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0896.webp`;
const p38 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0897.webp`;
const p39 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0898.webp`;

const p40 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0904.webp`;
const p41 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0905.webp`;
const p42 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0907.webp`;
const p43 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0908.webp`;
const p44 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0910.webp`;
const p45 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0916.webp`;
const p46 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0919.webp`;
const p47 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0922.webp`;
const p48 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0925.webp`;
const p49 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0926.webp`;

const p50 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0934.webp`;
const p51 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0943.webp`;
const p52 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_1026.webp`;
const p53 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryIMG_0983.webp`;

const p54 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryKG II - 1.webp`;
const p55 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryKG II - 2.webp`;
const p56 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryKG II - 3.webp`;
const p57 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryKG II - 4.webp`;
const p58 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryKG II - 8.webp`;
const p59 = `${config.base_image_archive_url}/academic-year-2021-22/home/home-static/our-campus/PhotogallryKG II - 5.webp`;



  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p5,
      source: p5,
      rows: 1,
      cols: 1,
    },
    {
      src: p6,
      source: p6,
      rows: 1,
      cols: 1,
    },
    {
      src: p7,
      source: p7,
      rows: 1,
      cols: 1,
    },
    {
      src: p8,
      source: p8,
      rows: 1,
      cols: 1,
    },
    {
      src: p9,
      source: p9,
      rows: 1,
      cols: 1,
    },
    {
      src: p10,
      source: p10,
      rows: 1,
      cols: 1,
    }, {
      src: p11,
      source: p11,
      rows: 1,
      cols: 1,
    },
    {
      src: p12,
      source: p12,
      rows: 1,
      cols: 1,
    },
    {
      src: p13,
      source: p13,
      rows: 1,
      cols: 1,
    },
    {
      src: p14,
      source: p14,
      rows: 1,
      cols: 1,
    },
    {
      src: p15,
      source: p15,
      rows: 1,
      cols: 1,
    },
    {
      src: p16,
      source: p16,
      rows: 1,
      cols: 1,
    },
    {
      src: p17,
      source: p17,
      rows: 1,
      cols: 1,
    },
    {
      src: p18,
      source: p18,
      rows: 1,
      cols: 1,
    },
    {
      src: p19,
      source: p19,
      rows: 1,
      cols: 1,
    },
    {
      src: p20,
      source: p20,
      rows: 1,
      cols: 1,
    },
    {
      src: p21,
      source: p21,
      rows: 1,
      cols: 1,
    },
    {
      src: p22,
      source: p22,
      rows: 1,
      cols: 1,
    },
    {
      src: p23,
      source: p23,
      rows: 1,
      cols: 1,
    },
    {
      src: p24,
      source: p24,
      rows: 1,
      cols: 1,
    },
    {
      src: p25,
      source: p25,
      rows: 1,
      cols: 1,
    },
    {
      src: p26,
      source: p26,
      rows: 1,
      cols: 1,
    },
    {
      src: p27,
      source: p27,
      rows: 1,
      cols: 1,
    },
    {
      src: p28,
      source: p28,
      rows: 1,
      cols: 1,
    },
    {
      src: p29,
      source: p29,
      rows: 1,
      cols: 1,
    },
    {
      src: p30,
      source: p30,
      rows: 1,
      cols: 1,
    },
    {
      src: p31,
      source: p31,
      rows: 1,
      cols: 1,
    },
    {
      src: p32,
      source: p32,
      rows: 1,
      cols: 1,
    }, 
    {
      src: p33,
      source: p33,
      rows: 1,
      cols: 1,
    },
    {
      src: p34,
      source: p34,
      rows: 1,
      cols: 1,
    },
    {
      src: p35,
      source: p35,
      rows: 1,
      cols: 1,
    },
    {
      src: p36,
      source: p36,
      rows: 1,
      cols: 1,
    },
    {
      src: p37,
      source: p37,
      rows: 1,
      cols: 1,
    },
    {
      src: p38,
      source: p38,
      rows: 1,
      cols: 1,
    },
    {
      src: p39,
      source: p39,
      rows: 1,
      cols: 1,
    },
    {
      src: p40,
      source: p40,
      rows: 1,
      cols: 1,
    },
    {
      src: p41,
      source: p41,
      rows: 1,
      cols: 1,
    },
    {
      src: p42,
      source: p42,
      rows: 1,
      cols: 1,
    },
    {
      src: p43,
      source: p43,
      rows: 1,
      cols: 1,
    },
    {
      src: p44,
      source: p44,
      rows: 1,
      cols: 1,
    },
    {
      src: p45,
      source: p45,
      rows: 1,
      cols: 1,
    },
    {
      src: p46,
      source: p46,
      rows: 1,
      cols: 1,
    },
    {
      src: p47,
      source: p47,
      rows: 1,
      cols: 1,
    },
    {
      src: p48,
      source: p48,
      rows: 1,
      cols: 1,
    },
    {
      src: p49,
      source: p49,
      rows: 1,
      cols: 1,
    },
    {
      src: p50,
      source: p50,
      rows: 1,
      cols: 1,
    },
    {
      src: p51,
      source: p51,
      rows: 1,
      cols: 1,
    },
    {
      src: p52,
      source: p52,
      rows: 1,
      cols: 1,
    },
    {
      src: p53,
      source: p53,
      rows: 1,
      cols: 1,
    },
    {
      src: p54,
      source: p54,
      rows: 1,
      cols: 1,
    },
    {
      src: p55,
      source: p55,
      rows: 1,
      cols: 1,
    }, {
      src: p56,
      source: p56,
      rows: 1,
      cols: 1,
    },
    {
      src: p57,
      source: p57,
      rows: 1,
      cols: 1,
    },
    {
      src: p58,
      source: p58,
      rows: 1,
      cols: 1,
    },
    {
      src: p59,
      source: p59,
      rows: 1,
      cols: 1,
    },
    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Box>
      <Box display={'flex'} justifyContent={'flex-end'} marginBottom={2}>
        {/* <Button
          color="primary"
          size="large"
          endIcon={
            <svg
              width={16}
              height={16}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          }
          onClick={() => openLightbox(0)}
        >
          Open the gallery
        </Button> */}
      </Box>
      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
  );
};

export default MostViewedArticles;